import { render, staticRenderFns } from "./u-dialog-flat-rounded.vue?vue&type=template&id=661a2592&scoped=true&"
import script from "./u-dialog-flat-rounded.vue?vue&type=script&lang=js&"
export * from "./u-dialog-flat-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a2592",
  null
  
)

export default component.exports